export const defaultStyles = {
  objectFit: "cover",
  objectPosition: "center",
  opacity: 1,
  borderRadius: {
    border_left_top_radius: 0,
    border_left_bottom_radius: 0,
    border_right_top_radius: 0,
    border_right_bottom_radius: 0,
  },
  sizing: {
    width: "100%",
    height: "384px",
    minWidth: "100px",
    minHeight: "100px",
    maxWidth: "100%",
    maxHeight: "auto",
  },
  padding: {
    paddingTop: "0",
    paddingBottom: "0",
    paddingRight: "0",
    paddingLeft: "0",
  },
  margin: {
    marginTop: "12",
    marginBottom: "12",
    marginRight: "32",
    marginLeft: "32",
  },
} as const;
